// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function removerCharacterEspecial(text: string) {
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z\s]/g, '')
    .toLowerCase();
}

export const cleanedCpfCnpj = (Data: string) => {
  return Data.replace(/[^\d]/g, '');
};
